export default [
    {
        meta: {
            requiresAuth: true,
            role: 'admin',
            layout: 'AdminLayout',
        },
        children: [
            {
                path: '/admin-hotel-dashboard',
                name: 'admin-hotel-dashboard',
                component: () => import('@/Pages/AdminHotel/Dashboard.vue'),
            },
            {
                path: '/admin-hotel-performance',
                component: () => import('@/Pages/AdminHotel/HotelPerformance/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'admin-hotel-performance',
                        component: () => import('@/Pages/AdminHotel/HotelPerformance/List.vue'),
                    },
                    {
                        path: ':id',
                        name: 'admin-hotel-performance-show',
                        component: () => import('@/Pages/AdminHotel/HotelPerformance/Show.vue'),
                    },
                ]
            },
            {
                path: '/admin-hotel-details',
                component: () => import('@/Pages/AdminHotel/Detail/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'admin-hotel-details',
                        component: () => import('@/Pages/AdminHotel/Detail/List.vue'),
                    },
                    {
                        path: ':id',
                        name: 'admin-hotel-details-show',
                        component: () => import('@/Pages/AdminHotel/Detail/Show.vue'),
                    },
                ]
            },
            {
                path: '/admin-hotel-inventory',
                component: () => import('@/Pages/AdminHotel/Inventory/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'admin-hotel-inventory',
                        component: () => import('@/Pages/AdminHotel/Inventory/List.vue'),
                    },
                    {
                        path: ':id',
                        name: 'admin-hotel-inventory-show',
                        component: () => import('@/Pages/AdminHotel/Inventory/Show.vue'),
                    },
                ]
            },
            {
                path: '/admin-hotel-employee',
                component: () => import('@/Pages/AdminHotel/Employee/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'admin-hotel-employee',
                        component: () => import('@/Pages/AdminHotel/Employee/List.vue'),
                    },
                    {
                        path: ':id',
                        name: 'admin-hotel-employee-show',
                        component: () => import('@/Pages/AdminHotel/Employee/Show.vue'),
                    },
                ]
            },
        ]
    }

]
